import PropTypes from 'prop-types';
import { compose, setPropTypes } from 'recompose';
import { connect } from 'react-redux';

import { BookingRecord } from '../entities/records';
import * as selectors from '../entities/Booking/selectors';

function mapStateToProps(state, { bookingId }) {
  return {
    booking: selectors.bookingById(state, bookingId),
  };
}

export default compose(
  setPropTypes({
    bookingId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  }),
  connect,
  setPropTypes({
    booking: PropTypes.instanceOf(BookingRecord),
  }),
)(mapStateToProps);
